import { Component, h, Host, Prop } from '@stencil/core';

import { CssClassMap } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-headline',
  styleUrl: 'cms-headline.scss',
  shadow: true,
})
export class CmsHeadline {
  /**
   * headline Text to display
   */
  @Prop({ reflect: true }) headlineText!: string;

  /**
   * Set Headline color
   */
  @Prop({ reflect: true }) colorToken: string;

  /**
   * set headline html tag like h1 ...
   */
  @Prop({ reflect: true }) headlineTag!:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6';

  /**
   *  set css class to display Headline or subheading
   */
  @Prop({ reflect: true }) headlineClass: string;
  /**
   *  set css class to position left or center
   */
  @Prop({ reflect: true }) headlinePosition: 'left' | 'center' = 'left';

  private headlineCssClass(): CssClassMap {
    return {
      [this.headlineClass]: true,
      [this.headlinePosition]: true,
      ['cms-headline']: true,
    };
  }

  render() {
    return (
      <Host>
        {this.headlineText && this.headlineTag ? (
          <div class={'headline-wrapper'}>
            <this.headlineTag
              style={
                this.colorToken
                  ? {
                      '--cms-theme-text-color': `var(${this.colorToken})`,
                    }
                  : null
              }
              class={this.headlineCssClass()}
            >
              {this.headlineText}
            </this.headlineTag>
          </div>
        ) : null}
      </Host>
    );
  }
}
